import { defaultCredentialsManager } from '../../credentials_provider/default_manager';
import { credentialsKey } from './api';
import { ClioCredentialsProvider } from './credentials_provider';
defaultCredentialsManager.register(credentialsKey, authServer => new ClioCredentialsProvider(authServer));
//# sourceMappingURL=register_credentials_provider.js.map